import React, { type FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';

import type { ReduxState } from 'app/redux/types';

import { isAlertError } from 'app/api/utils/error-alert-utils';
import { FormControl } from 'app/design-system/components/FormControl';
import { Modal } from 'app/design-system/components/Modal';
import { useTranslation } from 'app/lang';
import ModalResponseError from 'app/widgets/ModalResponseError';

import { InputField } from '../InputField';
import { getDictionary } from './utils';

import styles from './Body.module.scss';

const MAX_VALUE_LONG = 50;

type FormikValues = {
  value: string;
};

type Props = {
  selector: (state: ReduxState) => string | undefined;
  variant: 'city' | 'vatNumber' | 'email';
};

export const ModalBody: FC<Props> = ({
  selector,
  variant,
}) => {
  const { t } = useTranslation();
  const {
    values,
    setFieldValue,
    errors,
    touched,
  } = useFormikContext<FormikValues>();

  const value = useSelector(selector);
  useEffect(() => {
    if (value?.length) {
      setFieldValue('value', value);
    }
  }, []);

  const changeHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    let maxAllowableLengthValue = e.target.value;
    if (e.target.value.length > MAX_VALUE_LONG) {
      maxAllowableLengthValue = e.target.value.slice(0, MAX_VALUE_LONG);
    }
    setFieldValue(e.target.name, maxAllowableLengthValue);
  }, []);

  const dictionary = getDictionary(t, variant);

  return (
    <Modal.Body className={styles.body}>
      <ul className={styles.list}>
        <li className={styles.item}>

          <FormControl label={dictionary.label}
                       error={touched.value && errors.value}>
            <InputField value={values.value}
                        // disabled={Boolean(value?.length)}
                        name="value"
                        placeholder={dictionary.placeholder}
                        onChange={changeHandler} />
          </FormControl>
        </li>
      </ul>
      <ModalResponseError isError={isAlertError} />
    </Modal.Body>
  );
};
